import { signOut } from "aws-amplify/auth";
import { clearSelectedCustomerId } from "./customer_selection_storage";

/**
 * Custom logout function that clears local session and redirects to home page
 * without going through Cognito's hosted logout page
 */
export const customLogout = async (): Promise<void> => {
  try {
    // Clear the Amplify session locally
    await signOut({ global: true });

    // Clear any additional local storage items if needed
    clearSelectedCustomerId();

    // Force a page reload to reset the entire app state
    // This ensures the authentication context detects the logout
    window.location.href = "/";
  } catch (error) {
    console.error("Error during logout:", error);

    // Even if there's an error, still clear local storage and redirect
    clearSelectedCustomerId();
    window.location.href = "/";
  }
};
